import { Component, createApp } from 'vue';
import { Router } from 'vue-router';
import { VueQueryPlugin } from 'vue-query';
import { globalProperties } from './globalProperties';
import { pinia } from '@/stores';
import { setHTTPHeader } from '@/services/http.service';
import AuthService from '@/services/auth.service';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import PrimeVue from 'primevue/config';
import Dialog from 'primevue/dialog';
import 'primevue/resources/themes/lara-light-blue/theme.css';

const token = AuthService.getToken();

if (token) {
  setHTTPHeader({ Authorization: token });
}

export const setupEntryPoint = (rootComponent: Component, router: Router) => {
  const app = createApp(rootComponent);

  app.use(router);
  app.use(pinia);
  app.use(VueQueryPlugin);
  app.use(PrimeVue);
  app.config.globalProperties = {
    ...app.config.globalProperties,
    ...globalProperties,
  };
  app.component('Dialog', Dialog);
  app.component('v-select', vSelect);

  // Esperar a que el router resuelva la ruta inicial evita un flash del layout
  // por defecto (header del sitio) antes de que /login/etc. apliquen su chrome.
  router.isReady().then(() => app.mount('#app'));
};
